const sanatizePath = function(pth) {
  while (pth !== '/' && pth !== '' && pth.slice(-1) === '/') {
    pth = pth.slice(0, pth.length - 1)
  }
  return pth
}

const isNumeric = function(value) {
  return !isNaN(parseFloat(value)) && isFinite(value)
}

function parseBoolean(value, defaultValue) {
  value = (value === undefined) ? (defaultValue || false) : value
  if (typeof value === 'boolean') {
    return value
  }
  if (['true', 'yes', 't', 'y', '1', 'on', 'enable'].includes(value.toLowerCase())) {
    return true
  }
  else if (['false', 'no', 'f', 'n', '0', 'off', 'disable'].includes(value.toLowerCase())) {
    return false
  }
  return defaultValue
}

export default {
  isNumeric,
  sanatizePath,
  parseBoolean
}
